import DocMedsBundlesInfo from ".";

export default function DocMedBundleInfoExamples() {
  return (
    <DocMedsBundlesInfo
      onBackButtonClick={() => {
        console.log("Back button clicked");
      }}
      onContinueButtonClick={() => {
        console.log("Continue button clicked");
      }}
      contractsToSign={{
        ContractType: "DoctorMedicineBundle",
        Version: 1,
      }}
      memberProfile={null}
    />
  );
}
